<ion-list-header class="notifications-header">
  <ion-icon color="primary" size="large" name="document-text-outline"></ion-icon>
  <ion-text color="primary"><h3>Benachrichtigungen</h3></ion-text>
</ion-list-header>
<div class="notifications-list">
  <ion-list>
    <div *ngFor="let notification of notifications">
      <ion-grid>
        <ion-row class="ion-align-items-start">
          <ion-col size="auto">
            <ion-icon class="notification-icon" name="{{getNotificationIcon(notification)}}" color="{{getNotificationColor(notification)}}"></ion-icon>
          </ion-col>
          <ion-col size="auto" class="notification-date">
            <ion-row>{{notification.timestamp|date:'dd.MM.yyyy'}}</ion-row>
            <ion-row>{{notification.timestamp|date:'HH:mm'}}</ion-row>
          </ion-col>

          <ion-col *ngIf="notification.type === 'GENERAL'" class="ion-text-start notification-text">
            <ion-text class="ion-text-start ion-text-wrap">{{notification.payload}}</ion-text>
          </ion-col>

          <ion-col *ngIf="notification.type === 'LICENSE_EXPIRATION'" class="ion-text-start notification-text">
            <ion-text class="ion-text-start ion-text-wrap">Ihre exatrek Lizenz läuft in {{notification.payload}} Tagen ab!</ion-text>
          </ion-col>

          <ion-col *ngIf="notification.type === 'MACHINES_LONG_OFFLINE'" class="ion-text-start notification-text">
            <ion-text class="ion-text-wrap">{{notification.payload}} Maschinen waren längere Zeit offline</ion-text>
          </ion-col>

          <!-- Commented next line because throws error in build process -->
          <!-- <ion-col *ngIf="notification.type === 'DEADLINE'" class="ion-text-start notification-text">
            <ion-text class="ion-text-start ion-text-wrap">{{getDeadlineContent(notification.payload)}}</ion-text>
          </ion-col> -->

          <ion-col *ngIf="notification.type === 'EVENT'" class="ion-text-start notification-text">
            <ion-text class="ion-text-start ion-text-wrap">{{getEventContent(notification)}}</ion-text>
          </ion-col>

        </ion-row>
      </ion-grid>
    </div>
  </ion-list>
</div>
